import styled from 'styled-components';

export const ReceiptNumber = styled.div`
  text-transform: uppercase;
`;
